import { filter } from '@reatom/framework'

import type { Equivalence } from '@blade/std-lib'
import type { Atom, Ctx } from '@reatom/framework'

export const withEquivalence = <T>(equivalence: Equivalence.Equivalence<T>) => {
  return filter<Atom<T>>((ctx: Ctx, nextState: T, prevState: T) => {
    return !equivalence(prevState, nextState)
  })
}
